var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_68)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "#4A99EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 13.1312C30.191 13.4921 29.3219 13.736 28.4082 13.8462C29.3403 13.2844 30.0553 12.3929 30.3925 11.3316C29.5205 11.8525 28.5545 12.231 27.5265 12.4338C26.7029 11.5521 25.5305 11 24.2322 11C21.7402 11 19.719 13.0347 19.719 15.5454C19.719 15.9004 19.7597 16.2457 19.8353 16.5793C16.0827 16.3891 12.7584 14.5797 10.5318 11.831C10.1443 12.5041 9.92143 13.2844 9.92143 14.1154C9.92143 15.6917 10.7188 17.0836 11.929 17.898C11.1888 17.8736 10.4931 17.6698 9.88461 17.3294V17.3879C9.88461 19.5894 11.4397 21.426 13.5054 21.8435C13.1256 21.9469 12.7274 22.0015 12.3166 22.0015C12.0259 22.0015 11.742 21.9742 11.4668 21.9215C12.0414 23.726 13.7079 25.0409 15.6835 25.076C14.1381 26.2952 12.1916 27.0219 10.0774 27.0219C9.71312 27.0219 9.35365 27.0004 9 26.9585C10.9979 28.2489 13.3698 29 15.918 29C24.2215 29 28.7609 22.0766 28.7609 16.0721C28.7609 15.877 28.756 15.68 28.7473 15.4849C29.629 14.8431 30.3944 14.0442 30.9981 13.1342L31 13.1312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_68"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.cfeb7c97c5859efd95bf9c6e4cedcf3a.svg";
export { ForwardRef as ReactComponent };